import { checkForAtSignMentions } from '../../mention-shared/at-sign-matcher';
import { MentionRange } from './serialization';

export interface MentionTrigger {
  /** The query typed after the `@`, trimmed for searching. */
  query: string;
  /** Start index (the `@`) of the `@query` substring in display coordinates. */
  start: number;
  /** End index (exclusive) of the `@query` substring — the current caret. */
  end: number;
}

/**
 * Detect an active mention trigger ending at the caret. Returns null when the
 * text immediately before the caret is not a valid `@query`, or when the
 * candidate `@query` overlaps an existing resolved mention token — i.e. the
 * caret has moved inside or to the end of a token, so the regex is really
 * matching the token's own rendered `@Name` text rather than a new query.
 */
export function detectMentionTrigger(
  display: string,
  caret: number,
  mentions: MentionRange[] = []
): MentionTrigger | null {
  const match = checkForAtSignMentions(display.slice(0, caret), 1);
  if (!match) return null;
  const start = match.leadOffset;
  // A genuine in-progress query is plain text and never overlaps a token.
  if (mentions.some((m) => m.start < caret && m.end > start)) return null;
  return { query: match.matchingString.trim(), start, end: caret };
}
